export default "assets/images/icons/facebook-e9dbf11c.svg";